require('./bootstrap');
require('@fortawesome/fontawesome-free');

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';




import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { showAlert, goToUrl } from './utilities';

// 2019-03-13 expire    
// 30 day after, expire, '' current path , browser default
// Require dependencies 

// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;

// 2019-03-13 expire    
// 30 day after, expire, '' current path , browser default
// Require dependencies

// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

/* createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .mount(el);
    },
}); */

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name => {
        let parts = name.split('::')
        let type = false
        if (parts.length > 1) {
            type = parts[0]
        }
        if(type == "Base")
        {
            let nameVue = parts[1].split('.')[0]
            return require("@include/pages/" + nameVue + ".vue")
        } 
        if (type == "Include") { 
            let path = parts[1].split('.')[0];
           console.log(path);
            return require("@includeParent/Modules/" + path + ".vue")
        }

         if (type == "Global") { 
             let path = parts[1].split('.')[0]            
             return require("@global/" + path + ".vue")
         }
        else {
            return require(`./Pages/${name}`)
        }
    }),
    setup({ el, app, props, plugin }) { 

        const VueApp = createApp({ render: () => h(app, props) });
        VueApp.config.globalProperties.$utils = {
            showAlert,
            goToUrl
            // Add more utility functions here
        };

        return VueApp
            .use(plugin)
            .mixin({ methods: { route } })
            .mount(el);
    },
   
});

//InertiaProgress.init({color: '#3B82F6',includeCSS:true,showSpinner:true});

InertiaProgress.init({ color: '#29d', showSpinner: true })

//InertiaProgress.init();


